// 智慧消防
import Log from "../view/log";
import FireControlOverView from "../view/FireControl/FireControlOverView/FireControlOverView";
import GatewayDevice from "../view/FireControl/FireControlDeviceManage/GatewayDeviceManage/GatewayDevice";
import GatewayDeviceAdd from "../view/FireControl/FireControlDeviceManage/GatewayDeviceManage/GatewayDeviceAdd";
import GatewayDeviceModify from "../view/FireControl/FireControlDeviceManage/GatewayDeviceManage/GatewayDeviceModify";
import HydraulicPressureManage from "../view/FireControl/FireControlDeviceManage/HydraulicPressure/HydraulicPressureManage";
import HydraulicPressureAdd from "../view/FireControl/FireControlDeviceManage/HydraulicPressure/HydraulicPressureAdd";
import HydraulicPressureModify from "../view/FireControl/FireControlDeviceManage/HydraulicPressure/HydraulicPressureModify";
import LevelDeviceManage from "../view/FireControl/FireControlDeviceManage/LevelDeviceManage/LevelDeviceManage";
import LevelDeviceAdd from "../view/FireControl/FireControlDeviceManage/LevelDeviceManage/LevelDeviceAdd";
import LevelDeviceModify from "../view/FireControl/FireControlDeviceManage/LevelDeviceManage/LevelDeviceModify";
import SmokeSensationDeviceManage from "../view/FireControl/FireControlDeviceManage/SmokeSensationDeviceManage/SmokeSensationDeviceManage";
import SmokeSensationDeviceAdd from "../view/FireControl/FireControlDeviceManage/SmokeSensationDeviceManage/SmokeSensationDeviceAdd";
import SmokeSensationDeviceModify from "../view/FireControl/FireControlDeviceManage/SmokeSensationDeviceManage/SmokeSensationDeviceModify";
import TransmissionDevice from "../view/FireControl/FireControlDeviceManage/TransmissionDeviceManage/TransmissionDevice";
import TransmissionDeviceAdd from "../view/FireControl/FireControlDeviceManage/TransmissionDeviceManage/TransmissionDeviceAdd";
import TransmissionDeviceModify from "../view/FireControl/FireControlDeviceManage/TransmissionDeviceManage/TransmissionDeviceModify";
import PointPositionDevice from "../view/FireControl/FireControlDeviceManage/PointPositionDeviceManage/PointPositionDevice";
import PointPositionDeviceAdd from "../view/FireControl/FireControlDeviceManage/PointPositionDeviceManage/PointPositionDeviceAdd";
import PointPositionDeviceModify from "../view/FireControl/FireControlDeviceManage/PointPositionDeviceManage/PointPositionDeviceModify";
import FireControlCallPoliceRecord from "../view/FireControl/FireControlCallPoliceRecord/FireControlCallPoliceRecord";
import FireControlTransferRecord from "../view/FireControl/FireControlTransferRecord/FireControlTransferRecord";
import FireControlDeviceStateRecord from "../view/FireControl/FireControlDeviceStateRecord/FireControlDeviceStateRecord";
import FireControlNav from "../view/FireControl/FireControlNav";

export default [
  /* 智慧消防 */
  {
    path: "/fire_control_over_view",
    name: "fire-over-view",
    components: {
      default: FireControlNav,
      a: FireControlOverView
    }
  },
  {
    path: "/gateway_device",
    name: "gateway-device",
    components: {
      default: FireControlNav,
      a: GatewayDevice
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/gateway_device_add",
    name: "gateway-device-add",
    components: {
      default: FireControlNav,
      a: GatewayDeviceAdd
    }
  },
  {
    path: "/gateway_device_modify/:id",
    name: "gateway-device-modify",
    components: {
      default: FireControlNav,
      a: GatewayDeviceModify
    }
  },
  {
    path: "/hydraulic_pressure_manage",
    name: "hydraulic-pressure-manage",
    components: {
      default: FireControlNav,
      a: HydraulicPressureManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/hydraulic_pressure_add",
    name: "hydraulic-pressure-add",
    components: {
      default: FireControlNav,
      a: HydraulicPressureAdd
    }
  },
  {
    path: "/hydraulic_pressure_modify/:id",
    name: "hydraulic-pressure-modify",
    components: {
      default: FireControlNav,
      a: HydraulicPressureModify
    }
  },
  {
    path: "/level_device_manage",
    name: "level-device-manage",
    components: {
      default: FireControlNav,
      a: LevelDeviceManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/level_device_add",
    name: "level-device-add",
    components: {
      default: FireControlNav,
      a: LevelDeviceAdd
    }
  },
  {
    path: "/level_device_modify/:id",
    name: "level-device-modify",
    components: {
      default: FireControlNav,
      a: LevelDeviceModify
    }
  },
  {
    path: "/smoke_sensation_device_manage",
    name: "smoke-sensation-device-manage",
    components: {
      default: FireControlNav,
      a: SmokeSensationDeviceManage
    }
  },
  {
    path: "/smoke_sensation_device_add",
    name: "smoke-sensation-device-add",
    components: {
      default: FireControlNav,
      a: SmokeSensationDeviceAdd
    }
  },
  {
    path: "/smoke_sensation_device_modify/:id",
    name: "smoke-sensation-device-modify",
    components: {
      default: FireControlNav,
      a: SmokeSensationDeviceModify
    }
  },
  {
    path: "/transmission_device",
    name: "transmission-device",
    components: {
      default: FireControlNav,
      a: TransmissionDevice
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/transmission_device_add",
    name: "transmission-device-add",
    components: {
      default: FireControlNav,
      a: TransmissionDeviceAdd
    }
  },
  {
    path: "/transmission_device_modify/:id",
    name: "transmission-device-modify",
    components: {
      default: FireControlNav,
      a: TransmissionDeviceModify
    }
  },
  {
    path: "/point_position_device",
    name: "point-position-device",
    components: {
      default: FireControlNav,
      a: PointPositionDevice
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/point_position_device_add",
    name: "point-position-device-add",
    components: {
      default: FireControlNav,
      a: PointPositionDeviceAdd
    }
  },
  {
    path: "/point_position_device_modify/:id",
    name: "point-position-device-modify",
    components: {
      default: FireControlNav,
      a: PointPositionDeviceModify
    }
  },
  {
    path: "/fire_control_call_police_record",
    name: "fire-control-call-police-record",
    components: {
      default: FireControlNav,
      a: FireControlCallPoliceRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/fire_control_transfer_record",
    name: "fire-control-transfer-record",
    components: {
      default: FireControlNav,
      a: FireControlTransferRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/fire_control_device_state_record",
    name: "fire-control-device-state-record",
    components: {
      default: FireControlNav,
      a: FireControlDeviceStateRecord
    },
    meta: {
      keepAlive: true
    }
  },
  /* 智慧消防 */
  // 智慧消防操作日志
  {
    path: "/fire_control_log",
    name: "fire-control-log",
    components: {
      default: FireControlNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/FireControl.js